import { render, staticRenderFns } from "./dialog-check-idcard-mohpromt.vue?vue&type=template&id=0efa943d&"
import script from "./dialog-check-idcard-mohpromt.vue?vue&type=script&lang=js&"
export * from "./dialog-check-idcard-mohpromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports